var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-button',_vm._g({staticClass:"action-button",attrs:{"purple":"","disabled":_vm.disabled},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('span',{staticClass:"big-text mx-8"},[_vm._v(" "+_vm._s(_vm.text)+" ")])]},proxy:true}])},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }